import { put, call, takeLatest } from 'redux-saga/effects';
import * as documentsActions from './documentsActions';
import * as documentsTypes from './documentsTypes';
import * as documentsServices from 'src/services/documents.service';

const error = errorObject => {
  return errorObject.response ? errorObject.response : errorObject;
};

export function* getDocumentsSaga() {
  try {
    const data = yield call(documentsServices.fetchDocuments);

    if (!data.success) throw new error(data);

    yield put(documentsActions.getDocumentsSuccess(data));
  } catch (error) {
    console.warn(error);
    yield put(documentsActions.getDocumentsFailure(error));
  }
}

const documentsSaga = [takeLatest(documentsTypes.GET_DOCUMENTS_PENDING, getDocumentsSaga)];

export default documentsSaga;
